/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import {useIntl} from 'react-intl'

export default function useWithdrawalFields({
    form: {
        control,
        formState: {errors}
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        name: {
            name: `${prefix}name`,
            label: formatMessage({
                defaultMessage: 'Name',
                id: 'use_withdrawal_fields.label.name'
            }),
            type: 'text',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your name.',
                    id: 'use_withdrawal_fields.error.required_name'
                })
            },
            error: errors[`${prefix}name`],
            control
        },
        email: {
            name: `${prefix}email`,
            label: formatMessage({
                defaultMessage: 'Email',
                id: 'use_withdrawal_fields.label.email'
            }),
            placeholder: 'you@email.com',
            type: 'email',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your email address.',
                    id: 'use_withdrawal_fields.error.required_email'
                })
            },
            error: errors[`${prefix}email`],
            control
        },
        orderNumber: {
            name: `${prefix}orderNumber`,
            label: formatMessage({
                defaultMessage: 'Order Number',
                id: 'use_withdrawal_fields.label.order_number'
            }),
            type: 'text',
            defaultValue: '',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please enter your order number.',
                    id: 'use_withdrawal_fields.error.required_order_number'
                })
            },
            error: errors[`${prefix}orderNumber`],
            control
        }
    }
    return fields
}
